export interface CustomScreen {
  customScreenKey: string;
  name: string;
  widgetInstances: WidgetInstance[];
  availableCountries?: AvailableCountry[];
}

export enum WidgetKeys {
  GENERAL_WIDGET= 'GENERAL_WIDGET',
  HORIZONTAL_WIDGET = 'HORIZONTAL_WIDGET',
  VERTICAL_WIDGET = 'VERTICAL_WIDGET',
  IMAGE_WIDGET = 'IMAGE_WIDGET',
  ICON_WIDGET = 'ICON_WIDGET',
  CLUB_OCCUPANCY_WIDGET = 'CLUB_OCCUPANCY_WIDGET',
  SLIDER_WIDGET = 'SLIDER_WIDGET',
  THUMBNAIL_WIDGET = "THUMBNAIL_WIDGET",
  TITLE_WIDGET = "TITLE_WIDGET",
  TAB_WIDGET = "TAB_WIDGET",
  ACCOUNT_CONTROL_WIDGET = "ACCOUNT_CONTROL_WIDGET",
  POINTS_WIDGET = "POINTS_WIDGET",
  HEADER_INFO_WIDGET = "HEADER_INFO_WIDGET",
  DESCRIPTION_WIDGET = "DESCRIPTION_WIDGET",
  NO_POINTS_WIDGET = "NO_POINTS_WIDGET",
  HOME_POINTS_WIDGET = "HOME_POINTS_WIDGET",
  CARD_RECEIVAL_WIDGET = 'CARD_RECEIVAL_WIDGET',
}
export enum SliderWidgetKeys {
  GENERAL_WIDGET= 'GENERAL_WIDGET',
  HORIZONTAL_WIDGET = 'HORIZONTAL_WIDGET',
  VERTICAL_WIDGET = 'VERTICAL_WIDGET',
  IMAGE_WIDGET = 'IMAGE_WIDGET',
  ICON_WIDGET = 'ICON_WIDGET',
  CLUB_OCCUPANCY_WIDGET = 'CLUB_OCCUPANCY_WIDGET',
  THUMBNAIL_WIDGET = "THUMBNAIL_WIDGET",
}

export enum CustomScreenNames {
  HOME_SCREEN = 'HOME_SCREEN',
}

export interface WidgetParamArray {
  key: string;
  value: string | boolean;
}

export interface WidgetInstance {
  widgetInstanceId: string | number;
  widgetKey: WidgetKeys;
  startX?: number;
  startY?: number;
  width?: number;
  height?: number;
  params: WidgetParams;
}
export interface WidgetParams extends BaseWidgetParams {
  [key: string]: string;
}

interface BaseWidgetParams {
  title: string;
}

export interface CustomScreensList {
  customScreenKey: CustomScreenNames;
  name: string;
}

export interface AvailableCountry {
  countryId: number;
}
